const errorType = {
	word: ['char', 'word', 'idm'], // 字句错误
	punc: ['punc'], //标点错误
	miss: ['redund', 'miss', 'order', 'grammar_pc'] // 语法错误
}
const level3ExcludeKey = ['origin_text', 'section_id']
import { getErrorTextRegExp, hasErrorText } from '@/assets/js/editorError'
import { uuid } from 'vue-uuid'
import { get_tUser } from '@/assets/js/util'

export default {
	// 更新简历编辑状态下打开经历库状态标记
	setEmitShowLibrary(state, data) {
		state.emitShowLibrary = data
	},
	// 更新经历库显示状态
	updateLibraryState(state, data) {
		// 导师端不打开经历库
		if (state.isMentorCv) {
			return
		}
		state.libraryState = data
	},
	// 更新当前简历状态（是否是自己的简历）
	updateMyselfResumeState(state, data) {
		state.isMyselfResume = data
	},
  // 设置编辑经历库时默认收起状态
  upateAuxiliaryPackup(state, data) {
    state.auxiliaryPackup = data
  },
	// 修改当前简历中工作经历是否有子经历
	updateWorkHasSubItem(state, data) {
		state.hasWorkSubItem = data
	},
	// 修改公司名的 disabled
	updateCompanyDisabled(state, data) {
		state.companyIsDisabled = data
	},
	// 修改插入子经历的位置下标
	updateCommonIndex(state, index) {
		state.commonIndex = index
	},
	setGroupsEntryData(state, data) {
		state.groupsEntryData = data
	},
	setCvPortrait (state, data) {
		state.cvPortrait = data
	},
  setPortraitDialogVisible (state, data) {
    state.portraitDialogVisible = data
	},
  setJobTabScrollActive (state, data) {
    state.jobTabScrollActive = data
	},
  setShowJobTabCardDialog (state, data) {
    state.showJobTabCardDialog = data
	},
  setShowJobTabCardDialogSelf (state, data) {
    state.showJobTabCardDialogSelf = data
	},
  setShowJobTabCardDialogData (state, data) {
    state.showJobTabCardDialogData = data
	},
  setJobTabCardContentScrollY (state, data) {
    state.jobTabCardContentScrollY = data
	},
  setJobTabCardDialogTop (state, data) {
    state.jobTabCardDialogTop = data
	},
  setJobTabCardDialogTimer (state, data) {
    state.jobTabCardDialogTimer = data
	},
	setJobscanResultData (state, data) {
    state.jobscanResultData = data
	},
	// 设置是否是导师在编辑导师简历
	setMentorCv (state, data) {
		state.isMentorCv = data
	},
	//更新cv基本信息
	setCvDetail (state, data) {
		state.cvDetail = data
		state.cvToken = data.basic_info.token
	},
	//更新当前编辑数据,同时会创建一个备份
	setCurrentInfo (state, data) {
		// if (data.isCommon) {
		// 	// state.currentInfo = Object.assign(data, { data: { company: data.data.company, description: '', is_sub_item: true } })
		// 	// 去除多余 key 保持简历数据的引用关系（浅拷贝）
		// 	let keyArr = ['company', 'is_sub_item']
		// 	Object.keys(data.data).forEach(key => {
		// 		if (!keyArr.includes(key)) {
		// 			delete data.data[key]
		// 		}
		// 	})
		// 	data.data.description = ''
		// 	state.currentInfo = data
		// } else {
		// 	state.currentInfo = data
		// }
		state.currentInfo = data
		state.backUpInfo = JSON.parse(JSON.stringify(data))
	},
	//只更新当前编辑数据，不会修改当时的备份
	onlysetCurrentInfo (state, data) {
		state.currentInfo = data
	},
	// set profile 数据
	setProfileData (state, data) {
		state.profile = data
	},
	// set profile 备份数据
	setBackUpProfile (state, data) {
		state.backUpProfile = data
	},
	// set模块的数据
	setModuleData (state, { type, info }) {
		state[type] = info
	},
	// set extras 数据
	setExtrasData (state, info) {
		state.extras = info
	},
	// 自动排序后修改info数据
	setModuleDataBySort (state, { type, infos }) {
		state[type] = infos
	},
	// 更新简历设置数据 备份
	setBackUpFormatInfo (state, info) {
		state.backUpFormatInfo = info
	},
	// set check 的数据
	setCheckData (state, data) {
		state.score = data.score
		state.checkData = data.suggestions
		if (data.total_words !== state.wordCount) {
			state.wordCount = data.total_words
		}
		// state.wordCount = data.total_words || state.wordCount
	},
	// set 当前的分数
	setScore (state, score) {
		state.readyScore = score
	},
	// set 当前 error 的 信息
	setSuggestInfo (state, info) {
		state.suggestInfo = info
	},
	//更新一页纸方法
	setOnePageFunction (state, fn) {
		state.onePageFunction = fn
	},
	// set deal 布尔值
	setDealCheck (state, value) {
		state.dealCheck = value
	},
	// set auto one page Boolean
	setAutoOnePage (state, value) {
		state.autoOnePage = value
	},
	// 设置一页纸之前的行高
	setOldLineHeight (state, lineHeight) {
		state.oldLineHeight = lineHeight
	},
	// 设置faq的选项
	setFaqOptions (state, data) {
		state.faqOptions = data
	},
	//根据body宽度更改预览简历的宽度
	setResumeWidth (state, { value, type }) {
		const MAX_WIDTH = type === 'new' ? 720 : 420
		if (value <= 1280) {
			state.resumeWidth = 420
		} else if (value > 1280 && value <= 1440) {
			state.resumeWidth = (420 + (value - 1280)) > MAX_WIDTH ? MAX_WIDTH : (420 + (value - 1280))
		} else if (value > 1440) {
			state.resumeWidth = MAX_WIDTH
		}
	},
	//直接设置预览简历宽度
	setResumeWidthByValue (state, value) {
		state.resumeWidth = value
	},
	//修改是否展开
	setIsUnfold (state, value) {
		// if (typeof value === 'string') {
		// 	localStorage.setItem('on_off', value !== 'false')
		// 	state.isUnfold = value !== 'false'
		// } else {
		// 	localStorage.setItem('on_off', value)
		// 	state.isUnfold = value
		// }
		state.isUnfold = false
	},
	//设置是否需要取消当前编辑状态，并返回
	setCheckCloseEditModule (state, value) {
		state.checkCloseEditModule = value
	},
	//设置要打开的tab及打开状态
	setOpenSidebarModule (state, value) {
		state.openSidebarModule = value
	},
	//设置编辑次数
	setEditNumber (state, value) {
		state.editNumber = value
	},
	// 设置 check 的状态
	setScannerState (state, value) {
		state.showScanner = value
	},
	setSyncData (state, value) {
		state.syncSuccess = value
	},
	// 编辑中点击下一个模块时储存一个func用于点击保存或者不保存时调用
	setFormDataFn (state, value) {
		state.saveFormDataByDialog = value
	},
	// 获取小贴士
	setAssistInfo (state, { type, info }) {
		if (type === 'examples') {
			state.examples = info.examples || state.examples
			state.example_tags = info.example_tags || info.abilities || state.example_tags
			state.example_options = info.example_options || info.professions || state.example_options
		} else {
			state[type] = info[type]
		}
	},
	// 设置是否滚动的text-editor是否滚动
	setTextEditorScrollValue (state, value) {
		state.textEditorScrollTop = value
	},
	// 设置是否在请求中的状态
	setIsSendRequest (state, value) {
		state.isSendRequest = value
	},
	//设置jobscan引导
	setIsShowJobscanGuide(state, value){
		state.isShowJobscanGuide = value
	},
	//显示自动写简历错误信息
	setIsShowAutoWriteError(state, value){
		state.isShowAutoWriteError = value
	},
	//是否开启自动写简历
	setAutoModel(state, value){
		state.autoModel = value
		state.autoWriteList = []
		state.autoWriteTotal = 0
	},
	//设置职位id
	setPostId(state, value){
		state.postId = value
	},
	//更新自动写简历内容列表
	setAutoWriteList(state, list){
		state.autoWriteList = list
	},
	//更新自动写简历条数
	setAutoWriteTotal(state, total){
		state.autoWriteTotal = total
	},
	//自动写简历loading
	setAutoLoading(state, value){
		state.isAutoLoading = value
	},
	//自动写简历列表切换交互
	setAutoTransition(state, value){
		state.isAutoTransition = value
	},
	//是否有报告
	setHasJobscanRepor(state, value){
		state.hasJobscanRepor = value
	},
	setActiveTemplateStyle(state, obj){
		state.activeTemplateStyle = obj
	},
	//字数检查
	setShowWordNumHint(state, value){
		state.showWordNumHint = value
		setTimeout(()=>{
			state.showWordNumHint = false
		},5000)
	},
	//开关控制是不是显示下载简历的模块
	setIsShowDownloadResume(state, value){
		state.isShowDownloadResume = value
	},
	//修改触发判断中间变量
	emitShowDownBox(state, value){
		state.emitShowDownloadResumeBox = value
	},
	//修改下载后的无水印照片
	setNotWatermarkImage(state, value){
  	state.notWatermarkImage = value
	},
	//更新第一份简历信息
	setIsFirstCvInfo(state, value){
		state.isFirstCvInfo = value
	},

	// 更新简历纠错信息
	setResumeErrorInfo(state, value){
		let errorList = JSON.parse(JSON.stringify(value.errors));
		Object.keys(errorList).forEach(level1Key => {
			let level1Item = errorList[level1Key]
			if(level1Item){
				Object.keys(level1Item).forEach(level2Key => {
					let level2Item = level1Item[level2Key]
					if(level2Item){
						let originText = level2Item.origin_text; // 检索数据
						// 技能/证书及其他
						if(level1Key === 'extras'){

						} else if(level1Key === 'edus' || level1Key === 'works' || level1Key === 'orgs' || level1Key === 'infos'){
							let errorList = []
							Object.keys(level2Item).forEach(level3Key => {
								let level3Item = level2Item[level3Key]
								if(level3Item && !level3ExcludeKey.includes(level3Key)){
									level3Item.forEach((errorItem, errorIndex)=>{
										// console.log(level3Key, errorItem)
										// 不是所有的类型都要计算到错误里，需要整理及保存需要的数据
										// 格式类型满足 &&（非【语法纠错-冗余】类型&&修复成功文字为空）&& 未修复 && 过滤空格问题 && 不能包含&
										if(
											(errorType.word.includes(level3Key) || errorType.punc.includes(level3Key) || errorType.miss.includes(level3Key))
											&& (level3Key === 'redund' ? true : !!errorItem.correct_word
											&& !errorItem.is_correct
											&& hasErrorText(originText, errorItem.wrong_word, errorItem.index) //判断错误文字是能匹配到原文本里【18 ，会被变成 18，】
											&& !errorItem.wrong_word.includes('&'))
										){
											//存储原始的数据
											errorItem.error_original_type = level3Key
											if(errorType.word.includes(level3Key)){
												errorItem.error_type = 'word'
											}else if(errorType.punc.includes(level3Key)){
												errorItem.error_type = 'punc'
											}else if(errorType.miss.includes(level3Key)){
												errorItem.error_type = 'miss'
											}
											// 整理结束坐标
											errorItem.end = errorItem.index + errorItem.wrong_word.length
											errorItem.originalUuid = uuid.v1();
											errorItem.position = errorIndex; // 第几个位置
											// 拼接正则
											// errorItem.regExp = RegExp(getErrorTextRegExp(errorItem.wrong_word), 'g')
											errorItem.regExp = getErrorTextRegExp(errorItem.wrong_word)

											errorList.push(errorItem)
										}
									})

								}
							})
							// 调整错误信息的排序
							errorList.sort((a,b)=> { return a.index - b.index })

							// 过滤交叉 或包含的错误提示
							let spliceList = [];
							if(errorList.length > 1){
								errorList = errorList.filter((errorItem, errorIndex)=>{
									errorList.forEach((sErrorItem, sErrorIndex)=>{
										if(errorIndex < sErrorIndex){
											// (包含关系，前一个包含后一个 || 交叉) && 已经要删除了
											if( ( (errorItem.index <= sErrorItem.index && errorItem.end >= sErrorItem.end) || (errorItem.index <= sErrorItem.index && errorItem.end <= sErrorItem.end && errorItem.end > sErrorItem.index) )
												&& !spliceList.includes(sErrorIndex)
											){
												spliceList.push(sErrorIndex)
												// console.log(level1Key, '包含或交叉', sErrorIndex, errorItem, sErrorItem)
											}
										}
									})
									return !spliceList.includes(errorIndex)
								})
							}
							level2Item.errorList = errorList
						}

					}
				})
			}
		})

		console.log('纠错信息', {
			remain_times: value.remain_times,
			errors: errorList
		})
		state.resumeErrorInfo = {
			remain_times: value.remain_times,
			errors: errorList
		}

	},
	// 更新简历纠错次数
	setResumeErrorRemainTimes(state, remainTimes){
		state.resumeErrorInfo = {
			remain_times: remainTimes,
			errors: state.resumeErrorInfo.errors
		}
	},
	// 更新某一项纠错信息
	setResumeErrorItemInfo(state, value){
		let errorList = JSON.parse(JSON.stringify(state.resumeErrorInfo.errors))
		// console.log(errorList)
		let { moduleType, newOriginText, offsetSize, selectErrorInfo} = value;
		let { moduleId, infoId, modelData } = selectErrorInfo
		console.log('setResumeErrorItemInfo=>>',value)
		let moduleErrorList = null
		// 同步原始文字 拿到错误所在的列表数据
		if(moduleType === 'edus' || moduleType === 'works' || moduleType === 'orgs'){
			errorList[moduleType][moduleId].origin_text = newOriginText
			moduleErrorList = errorList[moduleType][moduleId].errorList
		}else {
			errorList.infos[infoId].origin_text = newOriginText
			moduleErrorList = errorList.infos[infoId].errorList
		}
		// 修改原数据中当前的状态 及 坐标
		moduleErrorList.forEach((item, index)=>{
			// 当前错误项向后的错误 && 当前错误的长度发生变化，修复当前错误后变的坐标
			if(modelData.errorInfo.index >= index && offsetSize !== 0){
				item.index += offsetSize
				item.end += offsetSize
			}
			if(item.originalUuid === modelData.errorInfo.originalUuid){
				item.is_correct = true
			}
		})
		// console.log('errorList=>>', errorList)
		// console.log('moduleErrorList=>>>', moduleErrorList)
		// 同步原始数据数据
		state.resumeErrorInfo = {
			remain_times: state.resumeErrorInfo.remain_times,
			errors: errorList
		}

		//修改当前筛选的错误类型的错误状态
		state.filterErrorInfo.forEach(moduleItem=>{
			if(moduleItem.id ? moduleItem.id === infoId : moduleItem.type === moduleType){
				moduleItem.errorInfos.forEach(infoItem=>{
					if(infoItem.moduleId === moduleId){
						// 修改原数据中当前的状态 及 坐标
						infoItem.originText = newOriginText
						infoItem.errorList.forEach((item, index)=>{
							// 当前错误项向后的错误 && 当前错误的长度发生变化，修复当前错误后变的坐标
							console.log(modelData, index, item, modelData.level3Index >= index)
							if(modelData.level3Index <= index && offsetSize !== 0){
								item.index += offsetSize
								item.end += offsetSize
							}
							if(item.originalUuid === modelData.errorInfo.originalUuid){
								item.is_correct = true
							}
						})
					}
				})
			}
		})

	},
	// 设置打开/关闭 纠错模式的状态
	setOpenResumeError(state, value){
		state.openResumeError = value
	},
	// 更新简历纠错类型
	setResumeErrorFilterType(state, value){
		state.resumeErrorFilterType = value
	},
	// 更新过滤之后数据
	setFilterErrorInfo(state, value){
		state.filterErrorInfo = value
	},
	// 更新选中之后数据
	setSelectErrorInfo(state, value){
		state.selectErrorInfo = value
	},
	// 更新错误uuid顺序列表
	setErrorUuidList(state, value){
		state.errorUuidList = value
	},
	//更新纠错购买弹窗
	setShowPurchasesErrorNumber(state, value){
		state.showPurchasesErrorNumber = value
	},
	//是否启动纠错状态
	setUseResumeError(state, value){
		state.useResumeError = value
	},
	// 更新小助手弹窗
	setEditorHelperPopup(state, value){
		// 存储到本地
		if(value.local){
			let c_t = get_tUser().c_t || ''
			let newData = {
				...value,
			}
			let localData = JSON.parse(localStorage.getItem(`${c_t}_helper_popup`) || "{}");
			delete newData.leaveDay
			delete newData.recommendJobItem
			Object.keys(newData).forEach(key=>{
				if(newData[key]){
					localData[key] = newData[key]
				}
			})
			localStorage.setItem(`${c_t}_helper_popup`, JSON.stringify(localData))
		}
		value.local = false
		state.editorHelperPopup = value
	},
	// 设置推出简历编辑状态
	setQuitResumeEditor(state, value){
		state.quitResumeEditor = value
	},
  setEditorMenuTipsType (state, data) {
    state.editorMenuTipsType = data
	}
}
